module.exports = __webpack_public_path__ + "static/media/reload.8ae13110.svg";